export default {
  data() {
    return {
      cleanupTimers: [],
      cleanupIntervals: [],
      cleanupEventListeners: [],
      cleanupObservers: [],
      cleanupSubscriptions: [],
    };
  },

  methods: {
    // Add timer for cleanup
    addCleanupTimer(timerId) {
      this.cleanupTimers.push(timerId);
    },

    // Add interval for cleanup
    addCleanupInterval(intervalId) {
      this.cleanupIntervals.push(intervalId);
    },

    // Add event listener for cleanup
    addCleanupEventListener(element, event, handler) {
      this.cleanupEventListeners.push({ element, event, handler });
    },

    // Add observer for cleanup
    addCleanupObserver(observer) {
      this.cleanupObservers.push(observer);
    },

    // Add subscription for cleanup
    addCleanupSubscription(subscription) {
      this.cleanupSubscriptions.push(subscription);
    },

    // Clean up all resources
    cleanupAllResources() {
      console.log('🧹 Cleaning up component resources...');

      // Clear timers
      this.cleanupTimers.forEach((timerId) => {
        clearTimeout(timerId);
      });
      this.cleanupTimers = [];

      // Clear intervals
      this.cleanupIntervals.forEach((intervalId) => {
        clearInterval(intervalId);
      });
      this.cleanupIntervals = [];

      // Remove event listeners
      this.cleanupEventListeners.forEach(({ element, event, handler }) => {
        if (element && element.removeEventListener) {
          element.removeEventListener(event, handler);
        }
      });
      this.cleanupEventListeners = [];

      // Disconnect observers
      this.cleanupObservers.forEach((observer) => {
        if (observer && observer.disconnect) {
          observer.disconnect();
        }
      });
      this.cleanupObservers = [];

      // Unsubscribe from subscriptions
      this.cleanupSubscriptions.forEach((subscription) => {
        if (subscription && subscription.unsubscribe) {
          subscription.unsubscribe();
        }
      });
      this.cleanupSubscriptions = [];

      // Clear large data arrays
      this.clearLargeDataArrays();

      console.log('✅ Component resources cleaned up');
    },

    // Clear large data arrays from component
    clearLargeDataArrays() {
      const largeDataKeys = [
        'dataList',
        'tableData',
        'chartData',
        'formData',
        'entityData',
        'templateData',
        'dashboardData',
        'cachedData',
        'filteredData',
        'searchResults',
      ];

      largeDataKeys.forEach((key) => {
        // Skip if it's a computed property (no setter)
        const isComputed = this.$options.computed && this.$options.computed[key];
        if (isComputed && !this.$options.computed[key].set) {
          return; // Skip computed properties without setters
        }

        // Skip if the property doesn't exist in the instance's data
        if (!Object.prototype.hasOwnProperty.call(this.$data, key)) {
          return; // Property is not in data, skip it
        }

        if (this[key] && Array.isArray(this[key])) {
          try {
            this[key] = [];
          } catch (e) {
            // Silently fail if we can't assign (e.g., it's a getter-only property)
            console.warn(`Could not clear ${key}:`, e.message);
          }
        }
      });
    },

    // Clear component state
    clearComponentState() {
      // Clear reactive data
      Object.keys(this.$data).forEach((key) => {
        if (key.startsWith('temp') || key.startsWith('cache') || key.startsWith('local')) {
          if (Array.isArray(this[key])) {
            this[key] = [];
          } else if (typeof this[key] === 'object' && this[key] !== null) {
            this[key] = {};
          } else {
            this[key] = null;
          }
        }
      });
    },
  },

  beforeDestroy() {
    this.cleanupAllResources();
    this.clearComponentState();
  },

  // Also cleanup on route change
  beforeRouteLeave(to, from, next) {
    this.cleanupAllResources();
    this.clearComponentState();
    next();
  },
};
